<!-- IF there is saved cards and we have user another payment toggle we need to add *ngIf="UseAnotherPayment" to the div-->
<div>
  <!-- <div class="form-group paymentMethod"> -->
  <div  class="form-group mt-3 mobile-payment"  *ngIf="depositeType!=DepositPolicyPaymentTypes.NoPaymentIsRequired">

    <h2>
      <div class="selected-class-title2">
        <!-- <fa-icon class="mr-2 selected-class-icon rounded-circle" [icon]="faDollarSign"></fa-icon> -->
        {{ 'PaymentMethod' | translate }}:
      </div>
    </h2>

    <div class="paymentMethodd">
      <mat-radio-group class="payment-images" (change)="changeComboo($event)" [(ngModel)]="selectedMethod">


        <mat-radio-button #btn [class.border-secondary]="btn.checked" class="d-inline"  tabindex="-1" *ngFor="let paymentMethod of paymentMethodList"
          [value]="paymentMethod.paymentGatewayLookupID">
          <img   placement="bottom" ngbPopover="{{ 'Paypal' | translate }}" triggers="mouseenter:mouseleave"
            class="payment-img payment-paypal-img mr-2 pt-2 pb-2 payment-img-border"
            src="assets/img/icons/paypal.jpg" *ngIf="paymentMethod.paymentGatewayLookupID==paymentMethods.PayPal">

          <img placement="bottom" ngbPopover="{{ 'AccountCredit' | translate }}" triggers="mouseenter:mouseleave"
            class="payment-img payment-account-img mr-2" src="assets/img/icons/wallet2.png"
            *ngIf="paymentMethod.paymentGatewayLookupID==paymentMethods.AccountCredit">

          <!-- <img placement="bottom" ngbPopover="{{ 'PayTabs' | translate }}" triggers="mouseenter:mouseleave"
            class="payment-img payment-account-img mr-2"
            src="assets/img/icons/paytabicon.jpg"
            *ngIf="paymentMethod.paymentGatewayLookupID==paymentMethods.PayTabs"> -->

          <div *ngIf="paymentMethod.paymentGatewayLookupID==paymentMethods.PayTabs">

          </div>

          <!-- <label class="mr-2" *ngIf="paymentMethod.paymentGatewayLookupID!=paymentMethods.PayPal">{{paymentMethod.defaultName}}</label> -->
        </mat-radio-button>
        <!--PayTabs Supported Methods-->
        <mat-radio-button *ngFor="let item of payTabsPaymentMethods" class="d-inline" tabindex="-1"
          [value]="item.paymentGatewayLookupID">
          <container-element [ngSwitch]="item.paymentMethodLookupID">
            <img placement="bottom" ngbPopover="{{ item.paymentMethodLookupName | translate }}" triggers="mouseenter:mouseleave"
              class="payment-img  mr-2 payment-img-border" src="assets/img/icons/visa.svg"
              *ngSwitchCase="paymentGatewayMethodEnum.Visa">

            <img placement="bottom" ngbPopover="{{ item.paymentMethodLookupName | translate }}" triggers="mouseenter:mouseleave"
              class="payment-img  mr-2 payment-img-border" src="assets/img/icons/mastercard.svg"
              *ngSwitchCase="paymentGatewayMethodEnum.MasterCard">

            <img placement="bottom" ngbPopover="{{ item.paymentMethodLookupName | translate }}" triggers="mouseenter:mouseleave"
              class="payment-img  mr-2 payment-img-border" src="assets/img/icons/amex.svg"
              *ngSwitchCase="paymentGatewayMethodEnum.AmericanExpress">

            <img placement="bottom" ngbPopover="{{ item.paymentMethodLookupName | translate }}" triggers="mouseenter:mouseleave"
              class="payment-img mr-2 payment-img-border" src="assets/img/icons/mada-logo.svg"
              *ngSwitchCase="paymentGatewayMethodEnum.Mada">


            <img placement="bottom" ngbPopover="{{ item.paymentMethodLookupName | translate }}" triggers="mouseenter:mouseleave"
              class="payment-img  mr-2 payment-img-border" src="assets/img/icons/credit-card.svg"
              *ngSwitchDefault>

          </container-element>
        </mat-radio-button>


      </mat-radio-group>
      <!-- <img (click)="onclickVisa()" ng-click="a = !a"
        class="payment-img payment-account-img mr-2 payment-img-border" src="assets/img/icons/visa.png">
      <img class="payment-img payment-account-img mr-2 payment-img-border" src="assets/img/icons/mastercard.jpg">
       -->
    </div>

    <div *ngIf="visaClicked">
      <form name="form" [formGroup]="form" (ngSubmit)="form.valid && onSubmit()">
        <div class="form-group row">
          <label class="col-form-label col-md-4" for="customerName">{{ 'CustomerName' | translate }}</label>
          <div class="col-md-8">
            <input (paste)="onPaste($event)" placeholder="{{  'Pleasedefine' | translate  }}" type="text" class="form-control"
              formControlName="customerName"
              [ngClass]="{'is-invalid':form.get('customerName').touched && form.get('customerName').invalid}"
              required />

          </div>
        </div>
        <div class="form-group row">
          <label class="col-form-label col-md-4" for="cardNo">{{ 'CardNo' | translate }}</label>
          <div class="col-md-6">
            <input placeholder="{{  'Pleasedefine' | translate  }}" type="number" class="form-control"
              formControlName="cardNo"
              [ngClass]="{'is-invalid':form.get('cardNo').touched && form.get('cardNo').invalid}" required />
          </div>
          <div class="col-md-2 pl-lg-0">
            <input placeholder="{{  'CVC' | translate  }}" type="number" class="form-control"
              formControlName="cardNo"
              [ngClass]="{'is-invalid':form.get('cardNo').touched && form.get('cardNo').invalid}" required />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-form-label col-md-4" for="securityCode">{{ 'SecurityCode' | translate }}</label>
          <div class="col-md-8">
            <input placeholder="{{  'Pleasedefine' | translate  }}" type="number" class="form-control"
              formControlName="securityCode"
              [ngClass]="{'is-invalid':form.get('securityCode').touched && form.get('securityCode').invalid}"
              required />

          </div>
        </div>

        <div class="form-group row">
          <label class="col-form-label col-md-4" for="expiryDate">{{ 'ExpiryDate' | translate }}</label>
          <div class="col-md-4 pr-md-0">
            <input placeholder="mm" type="number" class="form-control" formControlName="expiryDateMonth"
              [ngClass]="{'is-invalid':form.get('expiryDateMonth').touched && form.get('expiryDateMonth').invalid}"
              required />

          </div>
          <div class="col-md-4">
            <input placeholder="yy" type="number" class="form-control" formControlName="expiryDateYear"
              [ngClass]="{'is-invalid':form.get('expiryDateYear').touched && form.get('expiryDateYear').invalid}"
              required />

          </div>
        </div>
        <div class="form-group row">
          <label class="col-form-label col-md-4"></label>
          <div class="col-md-8">
            <mat-checkbox class="example-margin">{{ 'Addtosavedpaymentdetails' | translate }}</mat-checkbox>
          </div>
        </div>
      </form>
    </div>



    <div class="input-container mt-4">
      <!--Supported Payments-->
      <ng-container>
        <div *ngFor="let item of tenantRegisteredPaymentGatewayMethods">
          <!--<span>{{item.paymentMethodLookupName}}</span> -->
        </div>
      </ng-container>
      <!-- Method paypal-->
      <div *ngIf="selectedMethod!=null&&selectedMethod==paymentMethods.PayPal">
        <!-- <h1>paypal</h1> -->
        <button (click)="proceedPayment(paymentMethods.PayPal)" class="btn default-btn" mat-button>{{ 'Pay' |
          translate }}</button>



        <div class=" mt-3 post-back-msg" *ngIf="!isExportable && payPalPostBackMsg!=null&&payPalPostBackMsg!=''">
          <i class="fas fa-exclamation-circle mr-1 fa-2x"></i> {{ payPalPostBackMsg | translate}}   <a href="/">{{ 'SearchAgain' | translate }}</a>.
        </div>

      </div>



      <!--Account Credit-->
      <div *ngIf="selectedMethod!=null&&selectedMethod==paymentMethods.AccountCredit">
        <!-- <h1>paypal</h1> -->
        <button (click)="proceedPayment(paymentMethods.AccountCredit)" class="btn default-btn" mat-button>{{ 'Pay'
          |
          translate }}</button>
        <!--Msg's-->
        <!--The msg will be same as the key in ProceedPaymentResponseResult enum (add it to Resources)-->

        <div class=" mt-3 post-back-msg" *ngIf="accountCreditPostBackMsg!=null&&accountCreditPostBackMsg!=''">
          <i class="fas fa-exclamation-circle mr-1 fa-2x"></i>  {{ accountCreditPostBackMsg | translate}}
        </div>

      </div>
      <!--PayTabs-->
      <div class="row" *ngIf="selectedMethod!=null&&selectedMethod==paymentMethods.PayTabs">
        <!--Inclide the <script> ref in index.html-->
        <!-- Do the .sanitizer.bypassSecurityTrustHtml(this.payTabsContent); for the returned html -->
        <!-- Run the script inisde the innerHTML using eva; -->
        <!--The <form> tag not applied when adding throght innerHTML , this need to check why if not solution then we add it <form> static and iside it the dynamic html-->
        <!-- <div *ngIf="payTabsContentSafe != null"> -->
        <!--action="http://localhost/GCU.CarRental.Online.Api/api/Payment/PayTab" method="post"-->
        <!--action="#" data-url="http://localhost/GCU.CarRental.Online.Api/api/Payment/ProceedPayment" method="post"-->
        <div class="col-md-9">
          <div>


          </div>
          <form id="payform">
            <!-- <div #payTabHtmlContainer [innerHTML]="payTabsContentSafe"></div> -->


            <!-- <div class="row">
    <label>Card Number</label>
    <input type="text" data-paylib="number" size="20">
  </div> -->

            <div class="form-group">
              <label class="label" for="number">{{ 'NameOnCard' | translate }}</label>
              <input (paste)="onPasteNameOnCard($event)" [value]="pastedNameOnCard" placeholder="{{ 'NameOnCard' | translate }}" class="form-control" type="text">
            </div>

            <div class="row">
              <div class="col-md-8 pr-md-0">
                <div class="form-group">
                  <label class="label" for="number">{{ 'CardNumber' | translate }}</label>
                  <div class="input-group">
                    <!-- Removed Class input-card from Card Number filed if you want to return the brand name this class should be applied-->
                    <input (paste)="onPasteCardNumber($event)" [value]="pastedCardNumber" type="text" id="number" class="form-control input-card" data-paylib="number"
                      placeholder="1234 1234 1234 1234" autocomplete="off" aria-invalid="true" autocorrect="off"
                      spellcheck="false" aria-label="Card number" pattern="[0-9|#| ]*" inputmode="numeric">
                    <!-- <div class="input-group-append">
                      <span class="input-group-text card-type"><i class="pt-credit-card-brand"></i></span>
                    </div> -->

                  </div>
                  <div id="number-feedback" class="invalid-feedback"></div>
                  <!-- <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
                  <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Cardnumberisnotcorrect' | translate }}</div> -->
                </div>

              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="label" for="number">{{ 'CVC' | translate }}</label>
                  <input  (paste)="onPasteCVC($event)" [value]="pastedCVC" class="form-control"  id="cvv" type="number" data-paylib="cvv" size="4" placeholder="{{ 'CVC' | translate }}">
                  <div id="cvv-feedback" class="invalid-feedback d-block"></div>
                </div>
                <!-- <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
                <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Cardsecuritycodeisnotvalid' | translate }}</div> -->
              </div>
            </div>

            <div class="form-group">
              <label class="label" for="number">{{ 'ExpiryDate' | translate }}</label>
              <div class="row">
                <div class="col-md-3 pr-md-0 mb-2">
                  <input  placeholder="MM" class="form-control" id="expmonth" type="number" data-paylib="expmonth" size="2">
                  <div id="expmonth-feedback" class="invalid-feedback d-block"></div>
                </div>
                <div class="col-md-4">
                  <input placeholder="YYYY" class="form-control" type="number" id="expyear" data-paylib="expyear" size="4">
                  <div id="expyear-feedback" class="invalid-feedback d-block"></div>
                </div>
              </div>
              <!-- <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
              <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Creditcardisexpired' | translate }}</div> -->

            </div>

            <!-- <div class="form-group row">
              <div class="col-md-12">
                <mat-checkbox class="example-margin">{{ 'Addtosavedpaymentdetails' | translate }}</mat-checkbox>
              </div>
            </div> -->


            <input type="submit" value="{{ 'Pay' | translate }}" class="btn default-btn" mat-button [disabled]="payTabsFormIsDisable">














          </form>
        </div>
        <div class="col-md-3"></div>
      </div>


      <div class=" mt-3 post-back-msg">
        <span  *ngIf="validateMsg1"><i class="fas fa-exclamation-circle mr-1 fa-2x"></i></span>
        <span id="paymentErrors"></span>
      </div>

      <div class=" mt-3 post-back-msg">
        <span  *ngIf="validateMsg2"><i class="fas fa-exclamation-circle mr-1 fa-2x"></i></span>
        <span id="tookTooMuchTime"></span>
         <span class="ml-1"  *ngIf="validateMsg2"> <a href="/">{{ 'SearchAgain' | translate }}</a></span>
      </div>

    </div>
  </div>

</div>





<!--No Payment Required -->
<div *ngIf="depositeType==DepositPolicyPaymentTypes.NoPaymentIsRequired">
  <button (click)="proceedPayment(paymentMethods.NoPaymentRequired)" class="btn default-btn mt-4" mat-button>{{
    'Proceed'| translate }}</button>
    <div class=" mt-3 post-back-msg" *ngIf="accountCreditPostBackMsg!=null&&accountCreditPostBackMsg!=''">
      <i class="fas fa-exclamation-circle mr-1 fa-2x"></i> {{ accountCreditPostBackMsg | translate}}   <a href="/">{{ 'SearchAgain' | translate }}</a>.
    </div>

</div>
